
// Temp entity constants from Quake 2
export enum TempEntity {
  GUNSHOT = 0,
  BLOOD = 1,
  BLASTER = 2,
  RAILTRAIL = 3,
  SHOTGUN = 4,
  EXPLOSION1 = 5,
  EXPLOSION2 = 6,
  ROCKET_EXPLOSION = 7,
  GRENADE_EXPLOSION = 8,
  SPARKS = 9,
  SPLASH = 10,
  BUBBLETRAIL = 11,
  SCREEN_SPARKS = 12,
  SHIELD_SPARKS = 13,
  BULLET_SPARKS = 14,
  LASER_SPARKS = 15,
  PARASITE_ATTACK = 16,
  ROCKET_EXPLOSION_WATER = 17,
  GRENADE_EXPLOSION_WATER = 18,
  MEDIC_CABLE_ATTACK = 19,
  BFG_EXPLOSION = 20,
  BFG_BIGEXPLOSION = 21,
  BOSSTPORT = 22,
  BFG_LASER = 23,
  GRAPPLE_CABLE = 24,
  WELDING_SPARKS = 25,
  GREENBLOOD = 26,
  BLUEHYPERBLASTER = 27,
  PLASMA_EXPLOSION = 28,
  TUNNEL_SPARKS = 29,
  // ROGUE
  BLASTER2 = 30,
  RAILTRAIL2 = 31,
  FLAME = 32,
  LIGHTNING = 33,
  DEBUGTRAIL = 34,
  PLAIN_EXPLOSION = 35,
  FLASHLIGHT = 36,
  FORCEWALL = 37,
  HEATBEAM = 38,
  MONSTER_HEATBEAM = 39,
  STEAM = 40,
  BUBBLETRAIL2 = 41,
  MOREBLOOD = 42,
  HEATBEAM_SPARKS = 43,
  HEATBEAM_STEAM = 44,
  CHAINFIST_SMOKE = 45,
  ELECTRIC_SPARKS = 46,
  TRACKER_EXPLOSION = 47,
  TELEPORT_EFFECT = 48,
  DBALL_GOAL = 49,
  WIDOWBEAMOUT = 50,
  NUKEBLAST = 51,
  WIDOWSPLASH = 52,
  EXPLOSION1_BIG = 53,
  EXPLOSION1_NP = 54,
  FLECHETTE = 55,
  BLUEHYPERBLASTER_KEX = 56,
  BFG_ZAP = 57,
  BERSERK_SLAM = 58,
  GRAPPLE_CABLE_2 = 59,
  POWER_SPLASH = 60,
  LIGHTNING_BEAM = 61,
  EXPLOSION1_NL = 62,
  EXPLOSION2_NL = 63
}
